import { useMemo } from "react";

import { useViewDataConverter } from "./converter";

import type * as Repository from "./repository";
import type * as Type from "./type";

type QueryData = Repository.Query.QueryData.ReservationRequestList;
type ViewData = Type.ViewData;

type Props = {
	queryData: QueryData;
	filteredQueryData: QueryData;
};
type Result = {
	viewData: ViewData;
};

export const useViewData = ({ queryData, filteredQueryData }: Props): Result => {
	const { onConvertViewData } = useViewDataConverter();

	/**
	 * ViewData の取得
	 */
	const viewData = useMemo((): ViewData => {
		/**
		 * viewData への変換
		 */
		return onConvertViewData({ queryData, filteredQueryData }) satisfies ViewData;
	}, [filteredQueryData, onConvertViewData, queryData]);

	return {
		viewData,
	};
};
